export const getNumberOfDaysSince = (timestamp: string) => {
  let time = new Date().getTime() - new Date(timestamp).getTime();
  return Math.floor(time / 86400000);
};
